// extracted by mini-css-extract-plugin
module.exports = {"vision-and-strategy":"VisionAndStrategy_vision-and-strategy__e95DJ"};